import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faVimeoSquare } from '@fortawesome/free-brands-svg-icons/faVimeoSquare'

const brandsIcons = [
  faYoutube,
  faVimeoSquare
]

export default brandsIcons
